import { render, staticRenderFns } from "./Prikazi.vue?vue&type=template&id=580a1aec&"
import script from "./Prikazi.vue?vue&type=script&lang=js&"
export * from "./Prikazi.vue?vue&type=script&lang=js&"
import style0 from "./Prikazi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports